export const environment = {
  production: false,
  authServerUrl: 'https://int.api.access.lofous.com',
  appVersion: '1.0.0-integration',
};
